import { Layout } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ConditionalRenderer, Header, SideNavbar } from "components";
import { useCurrentUserContext } from "providers";
import { sidebarHideRoutes } from "./constants";
import { Tabs } from "./Tabs";
import { useRecoilState } from "recoil";
import { activeEnviornment } from "store/atom";
import { LiveIcon, SandboxIcon } from "icons";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import styles from "./styles.module.scss";
import { useEffect } from "react";
import Cookies from "js-cookie";

export function AppLayout({ authenticated, children }: any) {
  const navigate = useNavigate();

  const { user } = useCurrentUserContext();
  const [activeTab, setActiveTab] = useRecoilState<any>(activeEnviornment);
  const tabsArr = [
    {
      title: "Live",
      key: "live",
      icon: LiveIcon,
      color: "black",
      activeColor: "white",
    },
    {
      title: "Sandbox",
      key: "sandbox",
      icon: SandboxIcon,
    },
  ];

  const { pathname } = useLocation();

  const pathnameWithoutId = pathname.split("/")[1] || "";
  const cookie = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);

  const isShowSidebar = !sidebarHideRoutes.includes(pathnameWithoutId);
  useEffect(() => {
    const current = getCurrentEnviornment();
    if (!cookie) {
      localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
    }

    if (
      // `${current}_userId` &&
      localStorage.getItem(`${current}_userId`) &&
      cookie
    ) {
      navigate(window.location.pathname + window.location.search);
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem(ENVIORNMENTS.ENVIORNMENT, activeTab);
  }, [activeTab]);

  const handleChangeEnviornment = async (newEnviornment: any) => {
    if (
      !localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`) &&
      !localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`)
    ) {
      return;
    }
    if (localStorage.getItem(`${newEnviornment}_userId`)) {
      navigate("cases");
      window.location.reload();
    } else {
      navigate("/");
      window.location.reload();
    }

    // Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
    // localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
    // setLoading(true);
    // try {
    //   await getData({
    //     params: {
    //       secret_id: user?.secret_id,
    //     },
    //   });
    // } catch (error) {
    // } finally {
    //   setLoading(false);
    //   navigate("/");
    //   localStorage.setItem(ENVIORNMENT, newEnviornment);
    //   window.location.reload();
    // }

    // saveUserData(null);
  };

  return (
    <Layout
      style={{ minHeight: "100dvh", maxHeight: "100dvh", overflow: "hidden" }}
    >
      <Header showHeader={authenticated && user?.email} />
      <Layout>
        <ConditionalRenderer condition={isShowSidebar}>
          {user && <SideNavbar />}
        </ConditionalRenderer>
        <Layout>
          <Layout.Content style={{ backgroundColor: "white" }}>
            <div style={{ height: "100%" }}>{children}</div>
          </Layout.Content>
          <ConditionalRenderer condition={pathname !== "/otp-verification"}>
            <div className={styles.tabsWrapper}>
              <Tabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabsArr={tabsArr}
                // handleClick={() => console.log("hi")}
                handleClick={handleChangeEnviornment}
              />
            </div>
          </ConditionalRenderer>
        </Layout>
      </Layout>
    </Layout>
  );
}
